import React, { useEffect, useState } from 'react';
import { useNotification } from '@ancert/aui-notification-context';
import LoadingMask from '../../components/LoadingMask';
import { FormularDenunciaProvider } from '../../context/formularDenuncia.context';
import FormularDenunciaView from './FormularDenunciaRender';
import { getInstance } from '../../services/config.service';
import CONFIG_KEY from '../../constants/config.constants';

const FormularDenuncia = () => {
  const [data, setData] = useState([]);
  const { openNotification } = useNotification();
  const [isLoading, setIsLoading] = useState(true);

  const loadData = async () => {
    const { status, data: result, error } = await getInstance();
    if (status === 200) {
      const instance = result.find(({ key }) => key === CONFIG_KEY.DATOS_COMUNICACION);
      if (instance) {
        setData(JSON.parse(instance.value));
      }
      return;
    }
    const { message } = error;
    openNotification({
      title: 'Error',
      content: <div>{message || 'Ha ocurrido un error al recuperar los datos.'}</div>,
      type: 'error',
      centerButtons: true,
    });
  };
  useEffect(() => {
    setIsLoading(true);
    loadData();
    setIsLoading(false);
  }, []);

  return (
    <FormularDenunciaProvider dataComunicacion={data}>
      {isLoading ? <LoadingMask /> : <FormularDenunciaView data={data} />}
    </FormularDenunciaProvider>
  );
};

export default FormularDenuncia;
